<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import { GroupProps } from "~/components/Filters/Utils/Group.props"

const props = withDefaults(defineProps<GroupProps>(), {
  type: "default",
  contentClass: "",
  nFilters: 0,
  separator: true
})

const emit = defineEmits<{ (e: "onClick"): void; (e: "onReset"): void }>()
const slots = useSlots()
const isDefault = computed(() => props.type === "default")

const handleGroupClick = () => {
  if (isDefault.value) return
  emit("onClick")
}
const { getFiltersNumbersByState } = useSwiftSearchHelper()

const getFiltersNumbers = () => getFiltersNumbersByState(props.facetName)
</script>

<template>
  
<FormKitLazyProvider config-file="true">
<FormKit v-if="!!name" type="group" :name="name">
    <div class="group" :class="{ 'cursor-pointer': !isDefault }">
      <header
        class="group__header flex items-center justify-between gap-x-2 py-4"
        @click="handleGroupClick"
      >
        <div class="flex items-center gap-x-2">
          <p v-if="!!title" class="pig-bold">
            {{ title }}
          </p>
          <BadgeCounter :counter="getFiltersNumbers()" />
        </div>
        <!-- CLEAR REFINEMENTS -->
        <AisClearRefinements
          :included-attributes="facetName"
          :id="idFacet ?? ''"
        >
          <template v-slot="{ canRefine, refine }">
            <UtilsButton
              v-if="canRefine && isDefault"
              theme="ghost-green"
              :text="$t('filters.utils.common.reset')"
              @click="refine()"
            />
            <UtilsIcon
              name="ChevronRight.svg"
              v-else-if="!isDefault"
              class="h-6 w-6"
            />
            <div v-else></div>
          </template>
        </AisClearRefinements>
      </header>
      <div
        class="group__content cursor-default"
        :class="[contentClass, { 'border-b border-black-10': separator }]"
      >
        <slot />
      </div>
    </div>
    <slot v-if="!!slots.modal" name="modal" />
  </FormKit>
</FormKitLazyProvider>

</template>

<style lang="scss">

.group {
  .btn {
    &__container {
      @apply py-0;
    }
  }
}

</style>
